module.exports = __webpack_public_path__ + "static/media/mobile-tablet.291d3ba4.svg";